export const ServicesData = [
  {
    id: '1',
    service: 'Computer Repair',
    category: 'Computer',
    subCategory: 'Other',
    amount: '$80',
    duration: '10:00',
    date: '28 Sep 2022',
    status: 'Pending',
    createdBy: 'John Smith',
    img: 'assets/admin/img/services/service-03.jpg',
    img1: 'assets/img/customer/user-01.jpg',
  },
  {
    id: '2',
    service: 'Car Repair Services',
    category: 'Automobile',
    subCategory: 'Other',
    amount: '$50',
    duration: '12:30',
    date: '17 Sep 2022',
    status: 'Active',
    createdBy: 'Sharon',
    img: 'assets/admin/img/services/service-02.jpg',
    img1: 'assets/img/customer/user-02.jpg',
  },
  {
    id: '3',
    service: 'Steam Car Wash',
    category: 'Car Wash',
    subCategory: 'Other',
    amount: '$14',
    duration: '4:00',
    date: '13 Sep 2022',
    status: 'Inactive',
    createdBy: 'Amanda',
    img: 'assets/admin/img/services/service-04.jpg',
    img1: 'assets/img/customer/user-03.jpg',
  },
  {
    id: '4',
    service: 'House Cleaning',
    category: 'Cleaning',
    subCategory: 'Other',
    amount: '$100',
    duration: '5:30',
    date: '07 Sep 2022',
    status: 'Delete',
    createdBy: 'Sharonda',
    img: 'assets/admin/img/services/service-09.jpg',
    img1: 'assets/img/customer/user-04.jpg',
  },
  {
    id: '5',
    service: 'Building Construction',
    category: 'Cleaning',
    subCategory: 'Other',
    amount: '$100',
    duration: '8:30',
    date: '07 Sep 2022',
    status: 'Delete',
    createdBy: 'John Smith',
    img: 'assets/admin/img/services/service-08.jpg',
    img1: 'assets/img/customer/user-01.jpg',
  },
  {
    id: '6',
    service: 'Interior Designing',
    category: 'Interior',
    subCategory: 'Other',
    amount: '$100',
    duration: '11:00',
    date: '07 Sep 2022',
    status: 'Pending',
    createdBy: 'Amanda',
    img: 'assets/admin/img/services/service-07.jpg',
    img1: 'assets/img/customer/user-03.jpg',
  },
  {
    id: '7',
    service: 'Commercial Painting',
    category: 'Painting',
    subCategory: 'Other',
    amount: '$500',
    duration: '7:00',
    date: '22 Aug 2022',
    status: 'Inactive',
    createdBy: 'Sharon',
    img: 'assets/admin/img/services/service-09.jpg',
    img1: 'assets/img/customer/user-02.jpg',
  },
  {
    id: '8',
    service: 'Plumbing Services',
    category: 'Plumbing',
    subCategory: 'Other',
    amount: '$150',
    duration: '3:10',
    date: '15 Aug 2022',
    status: 'Delete',
    createdBy: 'John Smith',
    img: 'assets/admin/img/services/service-12.jpg',
    img1: 'assets/img/customer/user-01.jpg',
  },
];
